/**
 * Lightweight scroll restoration keyed by pathname + search (session-backed).
 */

const memory = new Map();
const STORAGE_PREFIX = "tra-scroll:";

export function scrollRestorationKey(pathname, search = "") {
  return `${pathname || "/"}${search || ""}`;
}

export function saveScrollPosition(pathname, search = "") {
  if (typeof window === "undefined") return;
  const key = scrollRestorationKey(pathname, search);
  const y = window.scrollY ?? 0;
  memory.set(key, y);
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, String(y));
  } catch {
    /* quota / private mode */
  }
}

export function restoreScrollPosition(pathname, search = "") {
  if (typeof window === "undefined") return;
  const key = scrollRestorationKey(pathname, search);
  let y = memory.get(key);
  if (y == null) {
    try {
      const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (raw != null) y = Number(raw);
    } catch {
      /* ignore */
    }
  }
  if (typeof y !== "number" || Number.isNaN(y)) return;
  requestAnimationFrame(() => {
    window.scrollTo({ top: y, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  });
}

/** @internal test helper */
export function resetScrollRestoration() {
  memory.clear();
}
